import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"position":"relative"} }

import { ref } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'HideOverflowDescription',
  props: {
    text: {}
  },
  setup(__props: any) {

const props = __props;
const show = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass((show.value ? 'text-wrap' : 'text-nowrap lh-1') + ' overflow-hidden w-100 d-inline-block endfade'),
      onMouseover: _cache[0] || (_cache[0] = ($event: any) => (show.value = true)),
      onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (show.value = false))
    }, _toDisplayString(_ctx.text), 35)
  ]))
}
}

})